import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "内容导航",
    links: [
      { label: "电影", to: "/category/movie" },
      { label: "电视剧", to: "/category/tv" },
      { label: "影视资讯", to: "/news" },
      { label: "搜索", to: "/search" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "使用说明", to: "/about" },
      { label: "免责声明", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-200 mt-auto">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-movie-2-fill text-xl"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">欲望之岛</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-md">
              欲望之岛是综合影视资讯与剧集推荐平台，聚焦电影与电视剧，帮助你快速获取影视动态、浏览剧集信息，并发现值得一看的精选作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-background-200">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-background-200">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-background-200">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 欲望之岛 · 本站内容均为演示虚构内容，仅供交流学习使用
          </p>
          <p className="text-xs text-background-400">联系邮箱：hello@yuwangzhidao.demo</p>
        </div>
      </div>
    </footer>
  );
}